
(() => {
  if (window.__rebuyPdpWidgetsInit) return;
  window.__rebuyPdpWidgetsInit = true;

  let lastCtxKey = null;
  let debounceTimer = null;

  const debug = (...args) => {
    if (window.__rebuyPdpDebug) console.log('[rebuy-pdp]', ...args);
  };

  function getPdpWidgetStateFromDOM() {
    // Map: widgetId -> syncEnabled(true/false)
    const map = new Map();

    document
      .querySelectorAll('.rebuy-widget[data-rebuy-context="pdp"][data-rebuy-id]')
      .forEach((el) => {
        const id = String(el.getAttribute('data-rebuy-id') || '').trim();
        if (!id) return;

        // Default: enabled, außer explizit "0"
        const enabled = el.getAttribute('data-cs-variant-sync') !== '0';

        // Wenn irgendwo für die gleiche ID enabled ist -> enabled bleibt true
        map.set(id, (map.get(id) || false) || enabled);
      });

    return map;
  }

  function getMainVariantPicker() {
    return (
      document.querySelector('variant-picker[data-template-product-match="true"]') ||
      document.querySelector('variant-picker')
    );
  }

  function readSelectedVariantFromPicker() {
    const picker = getMainVariantPicker();
    if (!picker) return null;

    const jsonEl = picker.querySelector('script[type="application/json"]');
    if (!jsonEl?.textContent) return null;

    try {
      return JSON.parse(jsonEl.textContent);
    } catch (e) {
      return null;
    }
  }

  function getPdpContext() {
    const picker = getMainVariantPicker();
    const variantObj = readSelectedVariantFromPicker();

    const urlVariant = new URL(window.location.href).searchParams.get('variant');

    const variantId = Number(urlVariant || variantObj?.id || 0) || null;
    const productId = Number(picker?.dataset.productId || 0) || null;

    // In Shopify Variant-JSON sind option1/option2 bei euch i.d.R. Farbe/Größe
    const option1 = variantObj?.option1 ?? null; // Farbe (typisch)
    const option2 = variantObj?.option2 ?? null; // Größe (typisch)

    return { variantId, productId, option1, option2 };
  }

  function findRebuyWidget(widgetId) {
    const widgets = window.Rebuy?.widgets;
    if (!Array.isArray(widgets)) return null;
    return widgets.find((w) => String(w.id) === String(widgetId)) || null;
  }

  function isVariantSyncEnabled(widgetId) {
    const nodes = document.querySelectorAll(
      `.rebuy-widget[data-rebuy-context="pdp"][data-rebuy-id="${String(widgetId)}"]`
    );

    // Default: enabled (damit bestehende Widgets unverändert weiterlaufen)
    if (!nodes.length) return true;

    // Wenn mindestens ein Mount nicht explizit "0" ist => enabled
    for (const el of nodes) {
      if (el.getAttribute("data-cs-variant-sync") !== "0") return true;
    }
    return false;
  }

  function syncMountAttributes(ctx) {
    document
      .querySelectorAll('.rebuy-widget[data-rebuy-context="pdp"][data-rebuy-id]')
      .forEach((el) => {
        // Sync deaktiviert? Dann Mount in Ruhe lassen
        if (el.getAttribute('data-cs-variant-sync') === '0') return;

        if (ctx.productId) el.setAttribute('data-rebuy-shopify-product-ids', String(ctx.productId));
        if (ctx.variantId) el.setAttribute('data-rebuy-shopify-variant-ids', String(ctx.variantId));
      });
  }

  function pickBestVariant(variants, ctx) {
    if (!Array.isArray(variants) || variants.length === 0) return null;

    const color = ctx.option1;
    const size = ctx.option2;

    // 1) exakter Match (Farbe+Größe)
    if (color && size) {
      const both = variants.find((v) => v.option1 === color && v.option2 === size);
      if (both) return both;
    }

    // 2) Farbe Match
    if (color) {
      const c = variants.find((v) => v.option1 === color);
      if (c) return c;
    }

    // 3) Größe Match
    if (size) {
      const s = variants.find((v) => v.option2 === size);
      if (s) return s;
    }

    // 4) Fallback: erste verfügbare, sonst erste
    return variants.find((v) => v.available) || variants[0];
  }

  function getWidgetProductsArray(widget) {
    return (
      widget?.data?.products ||
      widget?.products ||
      widget?.View?.products ||
      widget?.View?.$data?.products ||
      []
    );
  }

  function applyVariantPreference(widget, products, ctx) {
    if (!widget || !Array.isArray(products) || products.length === 0) return;

    const view = widget.View; // Vue instance

    for (const product of products) {
      const best = pickBestVariant(product?.variants, ctx);
      if (!best?.id) continue;

      // WICHTIG: beides reaktiv setzen (Vue2), sonst updated itemImage/price gern nicht zuverlässig
      if (view && typeof view.$set === 'function') {
        view.$set(product, 'selected_variant_id', best.id);
        view.$set(product, 'selected_variant', best);
      } else {
        product.selected_variant_id = best.id;
        product.selected_variant = best;
      }

      // Rebuy-Helper aktualisieren (Preis/Bild abhängig von Rebuy intern)
      if (view && typeof view.selectVariant === 'function') {
        try { view.selectVariant(product); } catch (_) {}
      }
    }
  }

  function syncWidget(widget, ctx) {
    if (!widget || !ctx.variantId) return;

    widget.data = widget.data || {};

    // Kontext setzen (max kompatibel)
    widget.data.shopify_variant_id = ctx.variantId;
    widget.data.shopify_variant_ids = [ctx.variantId];

    if (ctx.productId) {
      widget.data.shopify_product_id = ctx.productId;
      widget.data.shopify_product_ids = [ctx.productId];
    }

    const after = () => {
      const products = getWidgetProductsArray(widget);

      // Sicherstellen, dass Cards in deinem Slider die "richtige" Variant aktiv haben
      applyVariantPreference(widget, products, ctx);

      // Optional: falls Rebuy selbst keinen productsChange feuert, triggern wir ihn,
      // damit z.B. Slider-Init/Skeleton-Hide zuverlässig passiert.
      try {
        document.dispatchEvent(
          new CustomEvent('rebuy.productsChange', { detail: { widget, products } })
        );
      } catch (_) {}
    };

    // Force refetch via Rebuy Method
    if (typeof widget.getWidgetProducts === 'function') {
      widget.getWidgetProducts(() => {
        debug('refetched', widget.id, 'variant', ctx.variantId);
        after();
      });
    } else {
      debug('widget.getWidgetProducts missing for', widget.id);
      after();
    }
  }

  function syncAll(reason) {
    const ctx = getPdpContext();
    if (!ctx.variantId) return;

    const state = getPdpWidgetStateFromDOM();
    const enabledIds = Array.from(state.entries())
      .filter(([, enabled]) => enabled)
      .map(([id]) => id);

    // Wenn nichts zu synchronisieren ist, raus
    if (enabledIds.length === 0) return;

    const idsKey = enabledIds.join(',');
    const ctxKey = `${ctx.productId || ''}:${ctx.variantId}:${ctx.option1 || ''}:${ctx.option2 || ''}|${idsKey}`;
    if (ctxKey === lastCtxKey) return;
    lastCtxKey = ctxKey;

    debug('syncAll', reason, ctx, enabledIds);

    syncMountAttributes(ctx);

    for (const id of enabledIds) {
      const widget = findRebuyWidget(id);
      if (widget) syncWidget(widget, ctx);
    }
  }

  function scheduleSync(reason) {
    // Horizon updated DOM + replaceState passieren nicht immer synchron => kurze Debounce
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => syncAll(reason), 120);
  }

  // A) Variant Picker Interaktion
  document.addEventListener(
    'change',
    (e) => {
      const t = e.target;
      if (!(t instanceof Element)) return;
      if (t.closest('variant-picker')) scheduleSync('variant-picker change');
    },
    true
  );

  // B) URL Änderungen (Horizon nutzt history.replaceState)
  function hookHistory(method) {
    const original = history[method];
    if (typeof original !== 'function') return;

    history[method] = function (...args) {
      const ret = original.apply(this, args);
      window.dispatchEvent(new Event('rebuy:pdp:locationchange'));
      return ret;
    };
  }
  hookHistory('pushState');
  hookHistory('replaceState');

  window.addEventListener('popstate', () => scheduleSync('popstate'));
  window.addEventListener('rebuy:pdp:locationchange', () => scheduleSync('history state'));

  // C) Rebuy Lifecycle: wenn Widgets (neu) ready sind, sofort auf aktuellen PDP-Context setzen
  document.addEventListener('rebuy.ready', (event) => {
    const widget = event?.detail?.widget;
    if (!widget) return;

    const state = getPdpWidgetStateFromDOM();
    if (state.get(String(widget.id)) !== true) return;

    syncWidget(widget, getPdpContext());
  });

  // D) Nach jedem Products-Update: best-match Variant pro empfohlenem Produkt setzen
  document.addEventListener('rebuy.productsChange', (event) => {
    const { widget, products } = event?.detail || {};
    if (!widget) return;

    const state = getPdpWidgetStateFromDOM();
    if (state.get(String(widget.id)) !== true) return;

    applyVariantPreference(widget, products, getPdpContext());
  });

  // Initial
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => syncAll('domready'));
  } else {
    syncAll('init');
  }
})();
